import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { GoldenLayoutComponent } from "../../golden-layout/golden-layout-component";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { TranslateService } from "@ngx-translate/core";
import { GoldenLayoutPopout } from "app/golden-layout/golden-layout-popout";
import { Subscription } from "rxjs";
import { SysFeatures, UserLookupService } from "shared/cubiq-services";

import {
  FwdRollPricingCmd,
  FwdRollPricingCmdPayload,
  RowUnlockPayload,
} from "app/bfx-blotter-intervention/fwd-roll-pricing/models/fwd-roll-pricing-cmd-payload.model";
import { FwdRollPricingModel } from "app/bfx-blotter-intervention/fwd-roll-pricing/models/fwd-roll-pricing.model";
import { FwdRollPricingService } from "app/bfx-blotter-intervention/fwd-roll-pricing/services/fwd-roll-pricing.service";
import { BfxMouseModifierKeyService } from "app/bfx-common/services/bfx-mouse-modifier-key.service";
import { SystemConfigPromiseService } from "shared/auth-services";
import { BfxFwdRollBaseBlotterComponent } from "app/bfx-blotter-intervention/fwd-roll-pricing/bfx-fwd-roll-base-blotter";
import { DomHandler } from "@bfx/primeng/dom";
import { CALLOUT_TYPE } from "app/bfx-element-library/models/CalloutModel";

type ComponentConfigType = {
  orderBlotterConfig: any;
  netCcyBlotterConfig: any;
  netDealtPairBlotterConfig: any;
};
@Component({
  selector: "bfx-fwd-roll-pricing",
  templateUrl: "./html/bfx-fwd-roll-pricing-tabs.html",
  standalone: false,
})
export class FwdRollPricingComponent implements GoldenLayoutComponent, OnDestroy, AfterViewInit {
  public data = {
    ordersPanel: {},
    currenciesPanel: {},
    pairsPanel: {},

    icon: {
      directionUp: "up",
      directionDown: "down",
    },

    buttons: {
      refresh: {
        hidden: false,
        enabled: true,
      },
      save: {
        hidden: false,
        enabled: true,
      },
      price: {
        hidden: false,
        enabled: true,
      },
      close: {
        hidden: false,
        enabled: true,
      },
    },
    callout: {
      visible: false,
      type: "positive",
      message: null,
    },
  };

  public labelKeys = {
    buttons: {
      refresh: "fwd_roll.btn_refresh",
      save: "fwd_roll.btn_save",
      price: "fwd_roll.btn_price",
      close: "fwd_roll.btn_close",
      show: "fwd_roll.btn_show",
      hide: "fwd_roll.btn_hide",
    },
    tabs: {
      orders: "fwd_roll.panel_orders",
      summary: "fwd_roll.tab_summary",
    },
    general: {
      last_saved: "fwd_roll.last_saved",
      unsaved: "fwd_roll.unsaved",
      submit_success: "fwd_roll.submit_success",
      fetching_data: "fwd_roll.submit_success",
      portfolio_unlocked: "fwd_roll.portfolio_unlocked",
      refresh_error: "fwd_roll.refresh_error",
    },
  };

  public labels = {
    buttons: {
      refresh: "Refresh",
      save: "Save",
      price: "Price",
      close: "Close",
      show: "Show",
      hide: "Hide",
    },
    tabs: {
      orders: "Orders {{0}}",
      summary: "Summary,",
    },
    last_saved: "Last saved by {{0}} on {{1}}",
    unsaved: "Unsaved",
    footer_label: "Last saved by {{0}} on {{1}}",
    submit_success: "Orders priced successfully",
    fetching_data: "Fetching data",
  };

  /***************************************/
  /* DATA */

  public parentPopout: GoldenLayoutPopout;
  public viewInitComplete: boolean = false;
  //

  public portfolioModel: FwdRollPricingModel;
  private managerSubscription: Subscription;

  @ViewChild("ordersGrid")
  protected ordersGrid: BfxFwdRollBaseBlotterComponent;
  @ViewChild("currenciesGrid")
  protected currenciesGrid: BfxFwdRollBaseBlotterComponent;
  @ViewChild("pairsGrid")
  protected pairsGrid: BfxFwdRollBaseBlotterComponent;

  private showUserName: boolean;

  /****************************/
  /** Properties for Tabs     */
  public selectedTab: number = 0;

  public showTabs: boolean = true;

  // Splitter helper fields

  public height: number = 300;
  public minHeight: number = 100;
  /** Mouse Move handler for unlistening */
  private mouseMoveHandler: (e: MouseEvent) => void;
  /** Mouse up handler for unlistening  */
  private mouseUpHandler: (e: MouseEvent) => void;
  public py: number;
  public draggingCorner: boolean;
  @ViewChild("currenciesGrid", { static: true, read: ElementRef })
  private currenciesGridRef: ElementRef;

  private restoredConfig: ComponentConfigType;

  /**********************************************************************/
  /* CONSTRUCTOR  + LIFE CYCLE HOOKS */

  constructor(
    public translate: TranslateService,
    protected userLookupService: UserLookupService,
    private pricingService: FwdRollPricingService,
    _systemConfigService: SystemConfigPromiseService,
    protected mouseModifierKeyService: BfxMouseModifierKeyService,
    protected element: ElementRef,
    private cd: ChangeDetectorRef,
  ) {
    this.initialize();
    _systemConfigService.getSystemConfig(SysFeatures.displayUserNames).then((value: string) => {
      this.showUserName =
        value == "true" || value == "TRUE" || value == "1" || value == "Y" || value == "y";
    });
  }

  protected initialize(): void {
    // this.subscribeToManager();
  }
  protected initializeLabelTranslations(): void {
    const mapKeys = (keys, values, args?: any) => {
      for (let key in keys) {
        const translation = this.translate.instant(keys[key], args);
        if (translation) {
          values[key] = translation;
        }
      }
    };
    // For all keys in the keys object, get the label and add to labels object
    mapKeys(this.labelKeys.buttons, this.labels.buttons);
    mapKeys(this.labelKeys.tabs, this.labels.tabs, [this.portfolioModel?.orderCount]);
    // mapKeys( this.labelKeys.general, this.labels);

    this.initLastSavedLabel();

    this.labels.footer_label = this.labels.last_saved;
    // this.cd.detectChanges();
  }

  private initLastSavedLabel() {
    // May wany to do the Last Saved and others that take parameters separately
    const lastsaveUserId = this.portfolioModel.lastSaveUserId;
    if (lastsaveUserId != null) {
      const lastSaveUser = this.userLookupService.getItem(lastsaveUserId);
      let userName: string;
      if (lastSaveUser) {
        userName = this.showUserName ? lastSaveUser.userName : lastSaveUser.userCode;
      } else {
        userName = "<Unknown user>";
      }
      const dateStr = this.portfolioModel.lastSaveDate.local().format("DD-MMM-YY HH:mm:ss");
      this.labels.last_saved = this.translate.instant(this.labelKeys.general.last_saved, [
        userName,
        dateStr,
      ]);
    } else {
      this.labels.last_saved = this.translate.instant(this.labelKeys.general.unsaved);
    }
  }

  ngAfterViewInit() {
    const saved: ComponentConfigType = this.restoredConfig;
    if (saved) {
      this.ordersGrid.restoreFromConfiguration(saved.orderBlotterConfig);
      this.currenciesGrid.restoreFromConfiguration(saved.netCcyBlotterConfig);
      this.pairsGrid.restoreFromConfiguration(saved.netDealtPairBlotterConfig);
    }

    requestAnimationFrame(() => {
      if (this.element?.nativeElement) {
        this.portfolioModel.rootElement = this.element;
      }
    });
  }

  glInit(data: any, container: any, state: any): void {
    this.portfolioModel = data.payload as FwdRollPricingModel;

    this.initializeLabelTranslations();
    this.subscribeToManager();
    // BM open on Summary, Algos on Orders
    this.selectedTab = this.portfolioModel.isBMRoll ? 0 : 1;
    if (this.parentPopout) {
      this.parentPopout.title = this.portfolioModel.title;
    }
  }

  ngOnDestroy() {
    this.pricingService.interfaceOffline(this.portfolioModel);
    // this.pricingService.closeAll();
    if (this.managerSubscription) {
      this.managerSubscription.unsubscribe();
    }
  }

  /**
   * Called by GoldenLayout to save any component specific configuration
   * @returns
   */
  public getComponentConfiguration(): any {
    const orderBlotterConfig = this.ordersGrid.getComponentConfiguration();
    const netCcyBlotterConfig = this.currenciesGrid.getComponentConfiguration();
    const netDealtPairBlotterConfig = this.pairsGrid.getComponentConfiguration();

    const config: ComponentConfigType = {
      orderBlotterConfig,
      netCcyBlotterConfig,
      netDealtPairBlotterConfig,
    };

    return { componentConfig: config };
  }

  public restoreFromConfiguration(config: any): void {
    this.restoredConfig = config?.componentConfig as ComponentConfigType;
  }

  // /**********************************************************************/
  // /* MANAGER SUBSCRIPTION */

  private subscribeToManager(): void {
    this.managerSubscription = this.portfolioModel.interfaceCmd$.subscribe(
      ($event: FwdRollPricingCmdPayload) => {
        logger.out.info(
          `Manual-Price-Container: CMD = ${FwdRollPricingCmd[$event.cmd]} | payload = `,
          $event.payload,
        );
        switch ($event.cmd) {
          case FwdRollPricingCmd.START:
            this.resetState();
            this.pricingService.interfaceOnline(this.portfolioModel);
            this.labels.tabs.orders = this.translate.instant(this.labelKeys.tabs.orders, [
              this.portfolioModel?.orderCount,
            ]);
            // BM open on Summary, Algos on Orders
            this.selectedTab = this.portfolioModel.isBMRoll ? 0 : 1;
            break;
          case FwdRollPricingCmd.UPDATE_TITLE:
            if (this.parentPopout) {
              this.parentPopout.title = this.portfolioModel.title;
            }
            break;
          case FwdRollPricingCmd.DISABLE_FOR_PRICING:
            this.data.buttons.price.enabled = false;
            this.data.buttons.save.enabled = false;
            this.data.buttons.refresh.enabled = false;
            this.data.buttons.close.enabled = false;
            break;

          case FwdRollPricingCmd.PRICING_SUCCESS:
            this.data.buttons.price.hidden = true;
            this.data.buttons.save.hidden = true;
            this.data.buttons.refresh.hidden = true;
            this.data.buttons.close.enabled = true;
            // Add success callout
            this.addTerminalCalloutMessage("positive", this.labels.submit_success);
            break;
          case FwdRollPricingCmd.UNLOCK_FAIL:
          case FwdRollPricingCmd.PRICING_FAIL:
            this.data.buttons.price.enabled = true;
            this.data.buttons.save.enabled = true;
            this.data.buttons.refresh.enabled = true;
            this.data.buttons.close.enabled = true;
            break;
          case FwdRollPricingCmd.PRICING_SAVE_FAIL:
            this.data.buttons.price.enabled = true;
            this.data.buttons.save.enabled = true;
            this.data.buttons.refresh.enabled = true;
            this.data.buttons.close.enabled = true;
            break;
          case FwdRollPricingCmd.UNLOCK_SUCCESS:
            this.data.buttons.price.hidden = true;
            this.data.buttons.save.hidden = true;
            this.data.buttons.refresh.hidden = true;
            this.data.buttons.close.enabled = true;
            break;
          case FwdRollPricingCmd.PORTFOLIO_UNLOCKED:
            this.data.buttons.price.hidden = true;
            this.data.buttons.save.hidden = true;
            this.data.buttons.refresh.hidden = true;
            this.data.buttons.close.enabled = true;
            // Add info callout
            this.addTerminalCalloutMessage(
              "info",
              this.translate.instant(this.labelKeys.general.portfolio_unlocked, [$event.payload]),
            );
            break;
          case FwdRollPricingCmd.PORTFOLIO_REFRESH_ERROR:
            this.data.buttons.price.hidden = true;
            this.data.buttons.save.hidden = true;
            this.data.buttons.refresh.hidden = true;
            this.data.buttons.close.enabled = true;
            // Add negative callout
            this.addTerminalCalloutMessage(
              "negative",
              this.translate.instant(this.labelKeys.general.refresh_error, [$event.payload]),
            );
            this.pricingService.unlock(this.portfolioModel);
            break;
          case FwdRollPricingCmd.PRICES_SAVED:
            this.initLastSavedLabel();
            this.labels.footer_label = this.labels.last_saved;
            break;
          case FwdRollPricingCmd.LOCKED_STATE_CHANGED:
            // Intended for blotter components only
            break;
          case FwdRollPricingCmd.SERVER_ROW_UPDATED:
          case FwdRollPricingCmd.ROWS_UPDATED:
            // Intended for blotter components only
            break;
          case FwdRollPricingCmd.EDITOR_DISABLED_CHANGED:
            // this.cd.detectChanges();
            break;
          case FwdRollPricingCmd.REQUEST_FORWARD_FIRST_UNLOCK:
            this.confirmLockForPricing($event.payload as RowUnlockPayload);
            break;

          default:
            logger.out.warn(
              `ERROR: Fwd-roll: subscribeToManager(): Command not implemented! command= (${
                $event.cmd
              }) [${$event.cmd != null ? FwdRollPricingCmd[$event.cmd] : "NULL"}]`,
            );
            break;
        }
      },
    );
  }

  /**
   * Add a callout message - if a callout already exists, leave the type and existing message and just add new one.
   * This is only the case where refresh fails and we then unlock the order
   * @param type
   * @param message
   */
  private addTerminalCalloutMessage(type: CALLOUT_TYPE, message: string): void {
    this.labels.footer_label = null;
    if (this.data.callout.visible) {
      // We already have a terminal callout so just augment it
      this.data.callout.message = this.data.callout.message + "\n" + message;
    } else {
      // Add initial callout
      this.data.callout.visible = true;
      this.data.callout.type = type;
      this.data.callout.message = message;
    }
  }

  private resetState() {
    this.data.buttons.price.enabled = true;
    this.data.buttons.save.enabled = true;
    this.data.buttons.refresh.enabled = true;
    this.data.buttons.close.enabled = true;

    this.data.buttons.price.hidden = false;
    // AJB When Save and Refresh supported, change these to false
    this.data.buttons.save.hidden = false;
    this.data.buttons.refresh.hidden = false;

    // FXBFXOM-9595 - Clear the callout if a new event was picked up
    this.data.callout.visible = false;
    this.data.callout.message = "";

    this.initLastSavedLabel();
    this.labels.footer_label = this.labels.last_saved;
  }

  // /**********************************************************************/
  // /* ACTIONS */

  public price(): void {
    this.pricingService.pricePortfolio(this.portfolioModel);
  }

  public save(): void {
    this.pricingService.save(this.portfolioModel);
  }

  public refresh(): void {
    this.pricingService.refresh(this.portfolioModel);
  }

  // /**********************************************************************/
  // /* GOLDEN LAYOUT */

  public setParentPopup(parentPopup: GoldenLayoutPopout) {
    this.parentPopout = parentPopup;
    this.parentPopout.setShowDock(false);
    if (this.portfolioModel) {
      this.parentPopout.title = this.portfolioModel.title;
    }
  }

  public closeWindow(): void {
    this.pricingService.confirmClose(this.portfolioModel).then((save) => {
      if (save) {
        this.parentPopout.close();
      }
    });
  }

  // return false - cancels the popout closing
  public onClose(): boolean {
    this.pricingService.unlock(this.portfolioModel);
    return true;
  }

  public onTabSelected(event: any) {
    this.selectedTab = event.index;
  }

  public activateTabsView() {
    this.showTabs = true;
  }

  public activateVerticalView() {
    this.showTabs = false;
  }

  /**
   * Get confirmation promise form service and act on the results
   * @param payload
   */
  private confirmLockForPricing(payload: RowUnlockPayload) {
    const unlockPromise = this.pricingService.canUnlockForwardFirst();
    unlockPromise.then((value: boolean) => {
      if (value) {
        this.portfolioModel.setLockedForUserPricing(payload.portfolioId, payload.row, false);
      }
    });
  }

  // Splitter methods
  public onResizeClick(event: MouseEvent): void {
    this.mouseMoveHandler = this.onDragMove.bind(this);
    this.mouseUpHandler = this.onDragStop.bind(this);
    this.draggingCorner = true;
    this.py = event.clientY;

    event.preventDefault();
    event.stopPropagation();

    // AJB : cant't seem to use HostListener here as uses Main window in OpenFin
    if (this.element?.nativeElement) {
      let document: Document = DomHandler.getDocument(this.element.nativeElement);
      if (document) {
        document.addEventListener("mousemove", this.mouseMoveHandler);
        document.addEventListener("mouseup", this.mouseUpHandler);
      }
    }
  }

  private onDragMove(event: MouseEvent): void {
    if (!this.draggingCorner) {
      return;
    }
    let offsetY = event.clientY - this.py;

    this.height += offsetY;
    this.py = event.clientY;
  }

  private onDragStop(event?: MouseEvent): void {
    // this.draggingWindow = false;
    this.draggingCorner = false;
    this.height = this.currenciesGridRef?.nativeElement?.offsetHeight;

    // Remove explicit mouse listeners
    if (this.element?.nativeElement) {
      let document: Document = DomHandler.getDocument(this.element.nativeElement);
      if (document) {
        document.removeEventListener("mousemove", this.mouseMoveHandler);
        document.removeEventListener("mouseup", this.mouseUpHandler);
      }
    }
  }
}
